import { render, staticRenderFns } from "./menuEditdialog.vue?vue&type=template&id=770e1562&scoped=true"
import script from "./menuEditdialog.vue?vue&type=script&lang=js"
export * from "./menuEditdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e1562",
  null
  
)

export default component.exports